module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/9ccc8efaa2d64cf289504c60fd3a1bc1.png";